import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Non-O Marriage Visa — วีซ่าติดตามคู่สมรสไทย 1 ปี","metaTitle":"Non-O Marriage Visa Thailand — วีซ่าสมรสชาวต่างชาติ | NYC","metaDesc":"ยื่น Non-O Marriage Visa 1 ปี พร้อมเงินฝาก 400K หรือรายได้ 40K/เดือน ยื่นครบทุกขั้นตอน ที่ปรึกษามือหนึ่ง — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"Non-O Marriage Visa Thailand — 1-Year Spouse Visa","metaTitle":"Thailand Non-O Marriage Visa — Spouse of Thai National | NYC","metaDesc":"1-year Non-O Marriage Visa for spouses of Thai nationals. K deposit or K/month income. Full-service f — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/thai-visa/marriage")({
  head: () => {
    const url = `${SEO_SITE}/thai-visa/marriage`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/thai-visa/marriage", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/thai-visa/marriage", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/thai-visa/marriage", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/thai-visa/marriage", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/thai-visa/marriage", "/en/thai-visa/marriage")],
    };
  },
  component: () => <SubServicePage slug="thai-visa/marriage" locale="th" />,
});
